import { render } from "./m-list-item.vue?vue&type=template&id=05bc0784&scoped=true&ts=true"
import script from "./m-list-item.vue?vue&type=script&lang=ts"
export * from "./m-list-item.vue?vue&type=script&lang=ts"

import "./m-list-item.vue?vue&type=style&index=0&id=05bc0784&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05bc0784"]])

export default __exports__